/**
 * EPN-80 — a reusable, INLINE "you don't have permission for this" notice, for a section of an otherwise
 * reachable page (as opposed to `AccessDeniedPage`, a full-page replacement used for an entire denied
 * route). Mirrors that component's own tone/copy rather than inventing a second visual language for the
 * same concept. No "Request Access" action here either — that real workflow belongs to EPN-78, not this
 * ticket; inventing a second placeholder for it would just create two things to later reconcile.
 */
export function AccessDeniedNotice({ requiredPermissionLabel }: { requiredPermissionLabel?: string }) {
  return (
    <div className="access-denied-notice" role="alert" data-testid="access-denied-notice">
      <p>
        You don&rsquo;t have permission to view this.
        {requiredPermissionLabel && (
          <>
            {' '}
            This requires <strong>{requiredPermissionLabel}</strong>.
          </>
        )}
      </p>
      <p className="muted">
        If you believe this is a mistake, contact a company administrator who can review your role and
        permissions.
      </p>
    </div>
  );
}
